import { render, staticRenderFns } from "./AlertEventDialogThingsTabComponent.vue?vue&type=template&id=dda304aa&scoped=true"
import script from "./AlertEventDialogThingsTabComponent.js?vue&type=script&lang=js&external"
export * from "./AlertEventDialogThingsTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./AlertEventDialogThingsTabComponent.vue?vue&type=style&index=0&id=dda304aa&prod&scoped=true&lang=scss"
import style1 from "./AlertEventDialogThingsTabComponent.vue?vue&type=style&index=1&id=dda304aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda304aa",
  null
  
)

export default component.exports